import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: 'What is the cost of the fellowship?',
  a: 'The fellowship is heavily subsidized by The Sikh Initiative. Accepted students pay a nominal commitment fee of $50 to ensure attendance, but full scholarships are available for those with financial need.'
}, {
  q: 'When and where does it take place?',
  a: 'The 2026 cohort will run over three consecutive Saturdays in Fall 2026. Sessions are held in-person at a central location in Brampton.'
}, {
  q: 'Do I need to be Sikh to apply?',
  a: 'No. While the fellowship is rooted in Khalsa civic principles (courage, service, justice), it is open to all high school students in the GTA regardless of background.'
}, {
  q: 'When will I hear back if I applied?',
  a: 'Selected applicants will be informed by August 31, 2026. We review every application carefully and respond to all submissions.'
}, {
  q: 'What makes this different from a school club?',
  a: 'This is not a simulation. You will be building real venture proposals, learning from actual founders and investors, and receiving unvarnished, professional feedback.'
}, {
  q: 'What is the commitment level?',
  a: 'High. You are expected to attend all three full-day Saturday sessions and spend 2-3 hours during the week coordinating with your team.'
}, {
  q: 'How does the selection process work?',
  a: 'We look for initiative, not just grades. The process includes a written application and a short virtual interview.'
}];
export const FAQ = () => {
  return <section className="py-24 md:py-32 bg-parchment relative" data-id="element-86">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-87" />

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-88">
        <SectionHeader title="Frequently Asked Questions" centered data-id="element-89" />

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.1
          }
        }
      }} className="space-y-4" data-id="element-90">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-91" />)}
        </motion.div>
      </div>
    </section>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0
    }
  }} className="border border-bronze/20 bg-ivory rounded-sm overflow-hidden hover:border-kesari/40 transition-colors" data-id="element-92">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none hover:bg-kesari/5 transition-colors" aria-expanded={isOpen} data-id="element-93">
        <span className="font-serif text-lg text-navy pr-8" data-id="element-94">{question}</span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0,
        color: isOpen ? 'var(--color-kesari)' : 'var(--color-gold)'
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-95">
          {isOpen ? <Minus size={20} data-id="element-96" /> : <Plus size={20} data-id="element-97" />}
        </motion.span>
      </button>
      <AnimatePresence data-id="element-98">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-99">
            <div className="px-6 pb-5 font-sans text-charcoal/70 text-sm leading-relaxed border-t border-bronze/10 pt-4" data-id="element-100">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
};